/* Cart drawer: open/close, line updates via /cart/change.js (keys as strings,
   HP2), re-render through the Section Rendering API so data-cc-cart-line
   markers survive for the Bundle-in-cart embed. Dispatches cart:updated. */
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var lastFocused = null;
  function focusables() {
    return drawer.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
  }
  function open() {
    lastFocused = document.activeElement;
    drawer.classList.add('cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = focusables();
    if (f.length) setTimeout(function () { f[0].focus(); }, 60);
  }
  function close() {
    drawer.classList.remove('cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }
  window.tdtCartDrawer = { open: open, close: close, refresh: function () { return rerender(); } };

  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !drawer.classList.contains('cart-drawer--open')) return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('cart-drawer--open')) close();
  });

  /* On the cart page itself the drawer stays closed: its /cart/change.js edits
     would leave the page's positional updates[] form stale, and Shopify would
     re-apply the old quantities onto the wrong lines. */
  var onCartPage = !!document.querySelector('[data-cart-page]');
  document.querySelectorAll('a[href$="/cart"]').forEach(function (a) {
    if (a.closest('.cart-drawer') || onCartPage) return;
    a.addEventListener('click', function (e) {
      if (window.matchMedia('(min-width: 480px)').matches) { e.preventDefault(); open(); }
    });
  });

  function rerender() {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-cart-drawer]');
        if (!next) return;
        var body = drawer.querySelector('[data-cart-drawer-body]');
        var newBody = next.querySelector('[data-cart-drawer-body]');
        if (body && newBody) body.innerHTML = newBody.innerHTML;
        var foot = drawer.querySelector('.cart-drawer__foot');
        var newFoot = next.querySelector('.cart-drawer__foot');
        if (foot && newFoot) foot.innerHTML = newFoot.innerHTML;
        else if (foot && !newFoot) foot.remove();
        else if (!foot && newFoot && body) body.insertAdjacentElement('afterend', document.importNode(newFoot, true));
        var count = next.querySelector('[data-cart-drawer-count]');
        var curCount = drawer.querySelector('[data-cart-drawer-count]');
        if (count && curCount) curCount.textContent = count.textContent;
      });
  }

  function updateCart(total, count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (c) {
      c.textContent = count;
      c.classList.toggle('is-hidden', count === 0);
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { total: total, count: count } }));
  }

  drawer.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-drawer-qty]');
    if (!btn) return;
    var key = btn.dataset.lineKey; /* string, never parsed (HP2) */
    var delta = parseInt(btn.dataset.drawerQty, 10);
    var qtyEl = btn.parentElement && btn.parentElement.querySelector('.cart-drawer__qty-value');
    var current = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
    var quantity = delta === 0 ? 0 : Math.max(0, current + delta);
    var errEl = drawer.querySelector('[data-drawer-error]');
    if (errEl) errEl.classList.add('is-hidden');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
      .then(function (cart) {
        updateCart(cart.total_price, cart.item_count);
        return rerender();
      })
      .catch(function () {
        var err = drawer.querySelector('[data-drawer-error]');
        if (err) err.classList.remove('is-hidden');
      });
  });

  /* "+ N more…" expander for the theme-rendered bundle parts list
     (snippets/cart-bundle-parts.liquid) — works in the drawer and on the page,
     survives re-renders because it's delegated */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bundle-more]');
    if (!btn) return;
    var list = btn.closest('.cart-bundle__parts');
    if (list) list.querySelectorAll('[hidden]').forEach(function (li) { li.hidden = false; });
    var row = btn.closest('.cart-bundle__more');
    if (row) row.remove();
  });

  document.addEventListener('tdt:added', function () {
    rerender().then(open);
  });
})();
